import React, { FC, MouseEvent } from "react";
import { ResponsiveModal } from "@UI/Components/ResponsiveModal/ResponsiveModal";
import { CircleCheck } from "@UI/Components/Icons/CircleCheck";
import { VStack } from "@UI/Components/Stack/Stack";
import { Icon } from "@UI/Components/Icon/Icon";
import { Heading } from "@UI/Components/Heading/Heading";
import { Text } from "@UI/Components/Text/Text";
import { Button } from "@UI/Components/Button/Button";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";

import messages from "./messages";
import { PaymentMethodType } from "@modules/PaymentProcessing/types";
import { BrandPlus } from "@UI/Components/Icons/BrandPlus";
import { useDataMutation } from "@Libs/DataLayer/hooks/useDataMutation";

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onConfirm: () => any;
  isOpen: boolean;
  paymentMethod: PaymentMethodType;
  isPaymentConfirmed: boolean;
}

export const ConfirmationModal: FC<Props> = ({
  onConfirm,
  isOpen,
  isPaymentConfirmed,
  paymentMethod,
}) => {
  const handleConfirm = useDataMutation<void, void, MouseEvent>("confirm", () =>
    onConfirm()
  );

  return (
    <ResponsiveModal
      closeOnOverlayClick={false}
      closeOnEsc={false}
      isOpen={isOpen}
      closeButtonDisabled
      onClose={() => undefined}
    >
      <VStack justifyContent="center" spacing="4" pb={{ base: 2, md: 9 }}>
        <Icon as={CircleCheck} w="12" h="12" color="success" />
        <Heading>
          <FormattedMessage
            {...(!isPaymentConfirmed &&
            paymentMethod === PaymentMethodType.BANK_TRANSFER
              ? messages.waitingForBankTransfer
              : messages.paymentConfirmed)}
          />
        </Heading>
        <Text>
          <FormattedMessage
            {...messages.yourSubscriptionIsActivated}
            values={{
              plus: () => (
                <Icon
                  as={BrandPlus}
                  boxSize="5"
                  marginLeft="1"
                  display="inline"
                />
              ),
            }}
          />
        </Text>
        <Button
          w="full"
          onClick={handleConfirm.mutate}
          size="lg"
          colorScheme="seaGreen"
          data-testid="complete-subscription"
          isLoading={handleConfirm.isLoading}
        >
          <FormattedMessage {...messages.continue} />
        </Button>
      </VStack>
    </ResponsiveModal>
  );
};
